import React from "react";
import { withPrefix, Link } from "gatsby";
import styles from "./Author.module.scss";

const Author = ({ author, isIndex }) => (
  <div className={styles["author"]}>
    <Link to="/" className={styles["author-link"]}>
      <img src={"/logo.png"} style={{ width: 40 }} alt="Bearwood Labs Logo" />
    </Link>
  </div>
);

export default Author;
